import {Form, Input, message, Modal, ModalProps} from 'antd';
import React from 'react';
import Style from './index.module.scss';
import useRequestFn from '../../../../../Utils/Hooks/useRequestFn';
import {errorMessage} from '../../../../../Utils/common';
import {editAccount, AccountList, SaveAccount} from '../../service';
import SelectDict from '../../../../../Features/Select/SelectDict';
import {useDict} from '../../store';

interface Props extends ModalProps {
    onOk: () => void;
    data?: AccountList;
}

const Index = ({onOk, data, ...props}: Props) => {
    const dict = useDict();
    const [form] = Form.useForm<SaveAccount>();
    const [save, {loading: saveLoading}] = useRequestFn(editAccount);

    async function onFinish(formData: SaveAccount) {
        try {
            if (data?.id) {
                formData.id = data?.id;
            }
            await save(formData);
            message.success('编辑成功!');
            onOk();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <Modal
            {...props}
            width={600}
            title="编辑网站"
            confirmLoading={saveLoading}
            onOk={form.submit}>
            <div className={Style.root}>
                <Form
                    form={form}
                    onFinish={onFinish}
                    labelCol={{span: 5}}
                    initialValues={data}>
                    <Form.Item
                        name="accountType"
                        label="公众号类型"
                        rules={[{required: true}]}>
                        <SelectDict options={dict.AccountType.data} />
                    </Form.Item>
                    <Form.Item
                        name="nickname"
                        label="公众号名称"
                        rules={[{required: true}]}>
                        <Input placeholder="请输入" />
                    </Form.Item>
                    <Form.Item
                        name="wechatNumber"
                        label="公众号微信号"
                        rules={[{required: true}]}>
                        <Input placeholder="请输入" />
                    </Form.Item>
                    <Form.Item name="description" label="说明">
                        <Input.TextArea rows={5} placeholder="请输入" />
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    );
};

export default Index;
